module.exports = new __parcel__URL__("calendar-no-header-skeleton.tpl.d6779107.svg").toString();